export default __webpack_public_path__ + "static/media/tmb.071185e7.png";